import React, { useEffect, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useMarking from '../../../../../../hooks/maestro/useMarking'
import Countdown from 'react-count-down'
import { toggleAlertModule } from '../../../../../../store/actions/alert.actions'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import ItemMode from '../ModeMarking/ItemMode'
import CustomAvatar from '../../../../../avatar/Avatar'

import { Alert, Tooltip } from '@mui/material'
import { ContentTooltipStudentInfo } from '../ContentTooltip/ContentTooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SaveButtonForStudentStudentView = () => {
  const mode = useSelector((state) => state?.classMarking?.mode || [])
  const student = useSelector((state) => state?.classMarking?.student)
  const currentMode = mode?.find((item) => student?._id === item.studentId)
  const alertSave = useSelector((state) => state?.alert?.save || {})
  const dispatch = useDispatch()
  const { updateStudentMarkingByClassIdAndUlId } = useMarking()

  const onSave = async () => {
    await updateStudentMarkingByClassIdAndUlId(student, true)
  }

  useEffect(() => {
    if (currentMode) {
      if (!alertSave.mode || !alertSave.onSave) {
        dispatch(toggleAlertModule(false, 'Classes', 'marking', onSave, alertSave.onDontSave))
      }
    }
  }, [currentMode, alertSave])

  return (
    <div className='absolute bottom-0 z-12 flex flex-col gap-2 bg-background' style={{ zIndex: 100 }}>
      {currentMode && (
        <div className='bg-loading max-w-180px min-w-180px px-2 py-2'>
          <div className='py-2'>
            <Tooltip
              arrow
              placement='top'
              title={
                <Fragment>
                  <ContentTooltipStudentInfo student={currentMode} />
                  {currentMode.mode === 'error' && (
                    <Alert severity='error'>{currentMode.message || 'An error ocurred'}</Alert>
                  )}
                </Fragment>
              }
            >
              <div className={[''].join(' ')}>
                <div className='flex gap-2 items-center justify-start'>
                  <CustomAvatar alt={currentMode.code} src={`photos/${currentMode.photo}`} size='xsmall' />
                  <p className='text-ellipsis text-sm text-nowrap'>{currentMode.fullName}</p>
                </div>
                <div className='flex gap-2 items-center justify-end'>
                  <FontAwesomeIcon
                    icon={currentMode.mode === 'saving' ? 'circle-notch' : 'pencil'}
                    spin={currentMode.mode === 'saving'}
                    className='text-primary'
                  />
                  <span className='uppercase text-primary text-xs font-bold'>{currentMode.mode}</span>
                </div>
              </div>
            </Tooltip>
          </div>
          <ButtonStartIcon
            disabled={currentMode?.mode === 'saving'}
            startIcon={['fal', 'check']}
            loading={currentMode?.mode === 'saving'}
            onClick={onSave}
            className='font-bold w-full '
          >
            Save
          </ButtonStartIcon>
        </div>
      )}
    </div>
  )
}

export default SaveButtonForStudentStudentView
